import { useQuery } from "@apollo/client";
import { GET_CAMPAIGN_FEATURE_LINKS } from "queries/hooks";
const useGetCampaignFeatures = ({ campaignId }) => {
    var _a;
    const { loading, error, data } = useQuery(GET_CAMPAIGN_FEATURE_LINKS, {
        variables: { id: campaignId },
        onError: (err) => {
            console.error(err);
        },
    });
    const featuredByLinks = (_a = data === null || data === void 0 ? void 0 : data.campaignFeatureLinks) !== null && _a !== void 0 ? _a : [];
    return {
        featuredByLinks,
        loading,
        error,
    };
};
export default useGetCampaignFeatures;
